<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path id="Vector" d="M10.9372 0.583374C11.0245 0.583429 11.1108 0.603114 11.1895 0.640977C11.2683 0.67884 11.3375 0.733912 11.3922 0.802125L11.4359 0.863959L13.9151 4.94731C13.9721 5.04104 14.0015 5.14893 13.9999 5.25862C13.9984 5.3683 13.966 5.47532 13.9063 5.5674L13.8614 5.6269L7.44472 13.2103C7.39383 13.2704 7.33131 13.3195 7.26091 13.3548C7.19051 13.3901 7.11369 13.4107 7.0351 13.4155C6.9565 13.4203 6.87774 13.4092 6.80358 13.3827C6.72941 13.3563 6.66137 13.3151 6.60355 13.2616L6.55455 13.2103L0.137849 5.6269C0.0670689 5.54317 0.0213174 5.44119 0.0058412 5.33265C-0.00963504 5.22411 0.00579041 5.11341 0.0503489 5.01323L0.0841824 4.94731L2.56336 0.863959C2.60868 0.789222 2.67022 0.725624 2.74342 0.677866C2.81662 0.630108 2.89962 0.59941 2.98628 0.588041L3.06211 0.583374H10.9372ZM9.05006 5.8334H4.94863L6.99905 10.8921L9.05006 5.8334ZM12.1587 5.8334H10.3089L8.60731 10.0305L12.1587 5.8334ZM3.68979 5.8334H1.84003L5.39079 10.0293L3.68979 5.8334ZM4.47612 1.75005H3.38937L1.61836 4.66673H3.64253L4.47612 1.75005ZM8.30981 1.75005H5.68888L4.85529 4.66673H9.1434L8.30981 1.75005ZM10.6093 1.75005H9.52257L10.3562 4.66673H12.3803L10.6093 1.75005Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'BillingIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '14',
    },
    viewBox: {
      type: String,
      default: '0 0 14 14',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
